(function () {
  var tpl = document.getElementById('kg-ride-tpl');
  if (!tpl || !('content' in tpl)) return;

  var K_DONE = 'kg_ride_done';
  var K_CLOSED = 'kg_ride_closed';
  var K_SEEN = 'kg_ride_seen';
  var DAY = 86400000;
  var cfg = {
    company: tpl.getAttribute('data-company'),
    list: tpl.getAttribute('data-list'),
    revision: tpl.getAttribute('data-revision'),
    source: tpl.getAttribute('data-source')
  };
  var RIDES = { road: 1, gravel: 1, tri: 1, mtb: 1, multi: 1 };

  function store(kind) {
    try { return kind === 's' ? window.sessionStorage : window.localStorage; } catch (e) { return null; }
  }
  function get(kind, k) {
    try { var s = store(kind); return s ? s.getItem(k) : null; } catch (e) { return null; }
  }
  function set(kind, k, v) {
    try { var s = store(kind); if (s) s.setItem(k, v); } catch (e) {}
  }
  function push(o) {
    try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {}
  }

  function cookieIdentified() {
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return false;
    try {
      var j = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(j && (j.$exchange_id || j.$email || j.email || j.$phone_number));
    } catch (e) {
      return false;
    }
  }

  var forced = /[?&]kg_showpop=1(?:&|$)/.test(location.search);

  function suppressed() {
    if (forced) return false;
    if (get('l', K_DONE)) return true;
    var closed = parseInt(get('l', K_CLOSED) || '0', 10);
    if (closed && Date.now() - closed < 30 * DAY) return true;
    if (get('s', K_SEEN)) return true;
    if (/[?&](_kx|kg_nopop)=/.test(location.search)) return true;
    if (cookieIdentified()) return true;
    return false;
  }

  if (suppressed()) return;

  var mobile = window.matchMedia('(max-width: 767px)').matches;
  var startedAt = Date.now();
  var opened = false;
  var checking = false;
  var cleanups = [];

  function disarm() {
    cleanups.forEach(function (fn) { fn(); });
    cleanups = [];
  }

  function on(target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    cleanups.push(function () { target.removeEventListener(type, fn, opts); });
  }

  function klaviyoIdentified() {
    var k = window.klaviyo;
    if (!k || typeof k.isIdentified !== 'function') return Promise.resolve(null);
    return new Promise(function (resolve) {
      var done = false;
      var t = setTimeout(function () { if (!done) { done = true; resolve(null); } }, 2500);
      try {
        Promise.resolve(k.isIdentified()).then(function (yes) {
          if (done) return;
          done = true;
          clearTimeout(t);
          resolve(!!yes);
        }, function () {
          if (done) return;
          done = true;
          clearTimeout(t);
          resolve(null);
        });
      } catch (e) {
        done = true;
        clearTimeout(t);
        resolve(null);
      }
    });
  }

  function otherDialogOpen() {
    var nodes = document.querySelectorAll('[aria-modal="true"], .kl-private-reset-css-Xuajs1[role="dialog"]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.closest('[data-kg-ride]')) continue;
      if (n.getAttribute('aria-hidden') === 'true') continue;
      var cs = getComputedStyle(n);
      if (cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0') continue;
      var r = n.getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.right > 0 && r.bottom > 0 && r.left < window.innerWidth && r.top < window.innerHeight) return true;
    }
    return false;
  }

  function tryOpen(trigger) {
    if (opened || checking) return;
    if (document.visibilityState === 'hidden') return;
    if (suppressed()) { disarm(); return; }
    if (otherDialogOpen()) return;
    checking = true;
    klaviyoIdentified().then(function (yes) {
      checking = false;
      if (yes !== false && !forced) {
        disarm();
        return;
      }
      if (opened || suppressed() || otherDialogOpen()) return;
      disarm();
      open(trigger);
    });
  }

  function scrollPct() {
    var el = document.documentElement;
    var max = Math.max(el.scrollHeight, document.body.scrollHeight) - window.innerHeight;
    if (max < 200) return 0;
    return (window.scrollY || el.scrollTop || 0) / max;
  }

  function arm() {
    var threshold = mobile ? 0.5 : 0.4;
    var ticking = false;
    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (scrollPct() >= threshold) tryOpen('scroll');
      });
    }, { passive: true });

    var timer = setTimeout(function () { tryOpen('time'); }, Math.max(0, 20000 - (Date.now() - startedAt)));
    cleanups.push(function () { clearTimeout(timer); });
    on(document, 'visibilitychange', function () {
      if (document.visibilityState === 'visible' && Date.now() - startedAt >= 20000) tryOpen('time');
    });
    if (!mobile) {
      on(document, 'mouseout', function (e) {
        if (e.relatedTarget || e.toElement) return;
        if (e.clientY > 0) return;
        if (Date.now() - startedAt < 3000) return;
        tryOpen('exit');
      });
    }
  }

  var root, panel, lastFocus, ride = '', step = 1, prevOverflow = '';

  function focusables() {
    var current = panel.querySelector('.kg-ride__step:not([hidden])');
    var list = [panel.querySelector('.kg-ride__x')];
    if (current) list = list.concat(Array.prototype.slice.call(current.querySelectorAll('button, a[href], input')));
    return list.filter(function (el) { return el && !el.disabled && el.offsetParent !== null; });
  }

  function show(n) {
    step = n;
    root.querySelectorAll('.kg-ride__step').forEach(function (el) {
      el.hidden = el.getAttribute('data-step') !== String(n);
    });
    panel.setAttribute('aria-labelledby', 'kg-ride-t' + n);
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || active === panel || !panel.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  }

  function open(trigger) {
    opened = true;
    set('s', K_SEEN, '1');
    root = tpl.content.firstElementChild.cloneNode(true);
    panel = root.querySelector('.kg-ride__panel');
    if (mobile) root.classList.add('kg-ride--sheet');
    lastFocus = document.activeElement;
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.appendChild(root);
    document.addEventListener('keydown', onKey, true);
    wire();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-open'); });
    });
    panel.focus({ preventScroll: true });
    push({ event: 'kg_popup_view', kg_popup_trigger: trigger, kg_popup_layout: mobile ? 'sheet' : 'modal' });
  }

  function close() {
    if (!root) return;
    document.removeEventListener('keydown', onKey, true);
    if (step === 3) set('l', K_DONE, String(Date.now()));
    else set('l', K_CLOSED, String(Date.now()));
    push({ event: 'kg_popup_close', kg_popup_step: step });
    root.remove();
    root = null;
    document.documentElement.style.overflow = prevOverflow;
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function wire() {
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-kg-ride-close]')) { e.preventDefault(); close(); return; }
      if (t.closest('[data-kg-ride-back]')) { show(1); var b = root.querySelector('[data-ride="' + ride + '"]'); (b || panel).focus(); return; }
      var choice = t.closest('[data-ride]');
      if (choice) {
        ride = choice.getAttribute('data-ride');
        if (!RIDES[ride]) return;
        root.querySelector('[data-kg-ride-noun]').textContent = choice.getAttribute('data-noun') || 'bike';
        push({ event: 'kg_popup_answer', kg_riding: ride });
        show(2);
        root.querySelector('#kg-ride-email').focus();
      }
    });

    var form = root.querySelector('.kg-ride__form');
    var input = root.querySelector('#kg-ride-email');
    var err = root.querySelector('#kg-ride-err');
    var btn = form.querySelector('.kg-ride__submit');

    function fail(msg) {
      err.textContent = msg;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      err.textContent = '';
      input.removeAttribute('aria-invalid');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        fail('Check your email address and try again.');
        return;
      }
      if (!RIDES[ride]) { show(1); return; }
      btn.disabled = true;
      subscribe(email, ride).then(function (ok) {
        btn.disabled = false;
        if (!ok) {
          fail("That didn't go through. Check your email address and try again.");
          return;
        }
        set('l', K_DONE, String(Date.now()));
        push({ event: 'kg_popup_submit', kg_riding: ride });
        identify(email);
        show(3);
        var closeBtn = root.querySelector('[data-step="3"] .kg-ride__submit');
        if (closeBtn) closeBtn.focus();
      });
    });
  }

  function payload(email, riding) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { kg_riding: riding },
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };
  }

  function subscribe(email, riding) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company);
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: cfg.revision
      },
      body: JSON.stringify(payload(email, riding))
    }).then(function (r) {
      return r.status >= 200 && r.status < 300;
    }, function () {
      return false;
    });
  }

  function identify(email) {
    try {
      var k = window.klaviyo;
      if (!k || typeof k.identify !== 'function') return;
      var props = {};
      try {
        if (window.kgAttr && typeof window.kgAttr.profile === 'function') props = window.kgAttr.profile() || {};
      } catch (e) {}
      props.email = email;
      Promise.resolve(k.identify(props)).catch(function () {});
    } catch (e) {}
  }

  window.kgRidePopup = { payload: payload };

  function start() {
    if (forced) { open('preview'); return; }
    arm();
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
